import React from 'react';
import '../../App.css';

export default function Discord() {
  return window.location.href = "https://discord.gg/zgB6u6V4ns";
}
